/**
 * Open a git-managed (platform) chat skill in the main panel.
 * Platform skills are not documents - this is a read-only tab, not the editor.
 *
 * Workspace / personal skills use `open-document` instead.
 */

export const OPEN_PLATFORM_SKILL_EVENT = 'open-platform-skill'
export const PLATFORM_SKILL_TAB_PREFIX = 'platform-skill:'

export type OpenPlatformSkillDetail = {
  slug: string
  name: string
  category?: string
}

export function platformSkillTabId(slug: string): string {
  return `${PLATFORM_SKILL_TAB_PREFIX}${slug}`
}

export function isPlatformSkillTabId(id: string | null | undefined): boolean {
  return typeof id === 'string' && id.startsWith(PLATFORM_SKILL_TAB_PREFIX)
}

export function platformSkillSlugFromTabId(id: string): string {
  return id.startsWith(PLATFORM_SKILL_TAB_PREFIX)
    ? id.slice(PLATFORM_SKILL_TAB_PREFIX.length)
    : id
}

export function dispatchOpenPlatformSkill(detail: OpenPlatformSkillDetail): void {
  window.dispatchEvent(new CustomEvent(OPEN_PLATFORM_SKILL_EVENT, { detail }))
}
